import {
  Edit,
  SimpleForm,
  TextInput,
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  List,
  TextField,
  CheckboxGroupInput,
  NumberInput,
} from 'react-admin'
import {VertOnlineCategoryC} from 'shared/dist/types/VertOnlineOffer'
import LogoInput from './comps/LogoInput'

const offerFilters = [
  <TextInput label="Store Name" source="storeName" alwaysOn />,
]

export const OnlineOfferList = () => (
  <List filters={offerFilters}>
    <Datagrid rowClick="edit">
      <TextField source="storeName" />
      <TextField source="description" />
      <TextField source="vertOnlineCat" />
      <TextField source="title" />
      <BooleanField source="enabled" />
      <TextField source="lastChangedOn" />
      <TextField source="lastChangedBy" />
    </Datagrid>
  </List>
)

const OnlineOfferForm = () => (
  <SimpleForm
    maxWidth={700}
    validate={formValues => {
      return 'vertOnlineCats' in formValues
        ? {}
        : {
            vertOnlineCats: {
              message: 'Please select at least one category,',
              type: 'missing value',
            },
          }
    }}>
    <BooleanInput source="enabled" />
    <NumberInput source="priority" defaultValue={999} required />
    <CheckboxGroupInput
      label="Categories"
      source="vertOnlineCats"
      choices={VertOnlineCategoryC.types.map(({value}) => ({
        id: value,
        name: value,
      }))}
      // required
    />
    <LogoInput label="Online Store Logo" source="logoUri" />
    <TextInput source="storeName" label={'store name'} required />
    <TextInput
      source="description"
      label="store description"
      fullWidth
      multiline
    />
    <TextInput source="title" fullWidth required />
    <TextInput source="redemptionUri" label="URL to redeem" required />
    <TextInput source="promoCode" />
    <TextInput
      source="termsOfUse"
      label="terms of use"
      required
      fullWidth
      multiline
    />
    <TextInput source="phone" />
  </SimpleForm>
)
export const OnlineOfferEdit = () => {
  return (
    <Edit>
      <OnlineOfferForm />
    </Edit>
  )
}

export const OnlineOfferCreate = () => {
  return (
    <Create>
      <OnlineOfferForm />
    </Create>
  )
}
